// extracted by mini-css-extract-plugin
module.exports = {"item":"FlexItem_item__izlOg"};